const s = {
  styleOverrides: {
    root: ({ theme: o }) => ({
      padding: `${o.tokens.spacing[4]} ${o.tokens.spacing[4]} ${o.tokens.spacing[4]} ${o.tokens.spacing[16]}`,
      borderRadius: o.tokens.radius[8],
      backgroundColor: o.palette.background.level3,
      borderLeft: `${o.tokens.spacing[8]} solid`,
      outline: `1px solid ${o.palette.grey[300]}`,
      ...o.typography.body2
    }),
    action: ({ theme: o }) => ({
      marginRight: o.tokens.spacing[0],
      padding: `${o.tokens.spacing[4]} ${o.tokens.spacing[4]} ${o.tokens.spacing[4]} ${o.tokens.spacing[0]}`
    })
  }
}, n = {
  styleOverrides: {
    root: ({ theme: o }) => ({
      ...o.typography.body2
    })
  }
};
export {
  s as alert,
  n as alertTitle
};
//# sourceMappingURL=alert.mjs.map
